module.exports = __webpack_public_path__ + "img/vehicleicon_list.8928025e.jpg";